import Vue from 'vue';
import App from './components/App';
import i18n from './i18n';
import i18nVueValidate from './i18nVueValidate';
import store from './store';
import router from './router';
import {  LayoutPlugin, FormSelectPlugin, DropdownPlugin, FormGroupPlugin, FormCheckboxPlugin, FormInputPlugin, ButtonGroupPlugin, ButtonPlugin, ModalPlugin, TablePlugin, FormFilePlugin, FormPlugin, FormTextareaPlugin, ImagePlugin, BIcon, BIconImage, BIconCameraFill, BIconPlusSquareFill, BIconPlusCircleFill, BIconDashCircleFill, FormRadioPlugin, ToastPlugin, SpinnerPlugin } from 'bootstrap-vue';
import datePicker from "vue-bootstrap-datetimepicker";
import VueTextareaAutosize from "vue-textarea-autosize";
import VTooltip from 'v-tooltip';
import vSelect from "vue-select";
import VueSignaturePad from 'vue-signature-pad';
import { authState } from './services/AuthService';
import { ensureAuthInitialized } from './api/AuthApi';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/styles/globals.scss';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import "vue-select/dist/vue-select.css";
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import _ from 'lodash';

Vue.use(VueTextareaAutosize);
Vue.use(VTooltip);
[LayoutPlugin, FormSelectPlugin, DropdownPlugin, FormGroupPlugin, FormCheckboxPlugin, FormInputPlugin, ButtonGroupPlugin, ButtonPlugin, ModalPlugin, TablePlugin, FormFilePlugin, FormPlugin, FormTextareaPlugin, ImagePlugin, FormRadioPlugin, ToastPlugin, SpinnerPlugin ].forEach(comp => {
  Vue.use(comp);
});
Vue.use(datePicker);
Vue.use(VueSignaturePad);
Vue.use(i18nVueValidate);
Vue.component("v-select", vSelect);
Vue.component('BIcon', BIcon)
Vue.component('BIconImage', BIconImage)
Vue.component('BIconCameraFill', BIconCameraFill)
Vue.component('BIconPlusSquareFill', BIconPlusSquareFill)
Vue.component('BIconPlusCircleFill', BIconPlusCircleFill)
Vue.component('BIconDashCircleFill', BIconDashCircleFill)

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// Auth0の設定が存在するか確認
const hasAuth0Config = process.env.VUE_APP_AUTH0_DOMAIN && process.env.VUE_APP_AUTH0_CLIENT_ID;

// Auth0認証状態をVueインスタンスに追加
Vue.prototype.$auth = authState;

// アプリケーションの起動
async function startApp() {
  try {
    // Auth0の初期化（設定がある場合のみ）
    if (hasAuth0Config) {
      await ensureAuthInitialized();
    }
    
    // Vueインスタンスの作成とマウント
    new Vue({
      store,
      i18n,
      router,
      render: h => h(App),
    }).$mount('#app');
  } catch (error) {
    console.error('アプリケーションの起動に失敗しました:', error);
  }
}

// アプリケーションを起動
startApp();
